import type { ICaseStudy } from '@feathr/components';

import { backgroundImages as backgrounds, logos } from './assets';

export const caseStudies: ICaseStudy[] = [
  {
    background: backgrounds.campEagle,
    link: 'https://www.feathr.co/resources/case-studies/camp-eagle-reaches-165-new-campers-through-digital-outreach',
    logo: logos.campEagle,
    organization: 'Camp Eagle',
    published_date: 'Sep 12, 2023',
    read_time: '4 min',
    title: 'Camp Eagle reaches 165 new campers through digital outreach',
  },
  {
    background: backgrounds.qcso,
    link: 'https://www.feathr.co/resources/case-studies/qcso-sells-20k-in-tickets-with-a-single-email',
    logo: logos.qcso,
    organization: 'QCSO',
    published_date: 'Nov 13, 2023',
    read_time: '1 min',
    title: 'QCSO uses Feathr to maximize concert attendance',
  },
  {
    background: backgrounds.unitedWay,
    link: 'https://www.feathr.co/resources/case-studies/united-way-increases-program-awareness-with-digital-marketing',
    logo: logos.unitedWay,
    organization: 'United Way of Asheville and Buncombe County',
    published_date: 'Nov 13, 2023',
    read_time: '1 min',
    title: 'United Way increases program awareness with Feathr',
  },
  {
    background: backgrounds.aae,
    link: 'https://www.feathr.co/resources/case-studies/aae-earns-649k-in-ticket-sales-with-feathr',
    logo: logos.aae,
    organization: 'American Association of Endodontists',
    published_date: 'Jun 12, 2024',
    read_time: '9 min',
    title: 'AAE earns $649k in ticket sales to annual conference with Feathr',
  },
  {
    background: backgrounds.same,
    link: 'https://www.feathr.co/resources/case-studies/same-gains-235-attendee-registrations-with-digital-ads',
    logo: logos.same,
    organization: 'Society of American Military Engineers',
    published_date: 'Jun 26, 2024',
    read_time: '3 min',
    title: 'SAME gains 235 attendee registrations with digital ads',
  },
  {
    background: backgrounds.feathrIntelligence,
    link: 'https://www.feathr.co/resources/newsroom/feathr-expands-nonprofit-marketing-platform-with-ai-powered-intelligence-and-integrated-fundraising?hsCtaAttrib=195570122094',
    logo: logos.feathr,
    organization: 'Feathr',
    published_date: 'September 10, 2025',
    read_time: '3 min',
    title:
      'Feathr Expands Nonprofit Marketing Platform With AI-Powered Intelligence and Integrated Fundraising',
    callToAction: 'Read press release',
  },
  {
    background: backgrounds.fundraisingPaysYouBack,
    link: 'https://www.feathr.co/resources/events/fundraising-that-pays-you-back',
    logo: logos.feathr,
    organization: 'Feathr',
    published_date: 'Dec 16, 2025',
    read_time: '1 min',
    title: 'Fundraising That Pays You Back',
    expirationDate: new Date('2025-12-16T20:00:00Z'),
    callToAction: 'Register now',
  },
];

export default caseStudies;
